import { render } from "./ProfileDropdown.vue?vue&type=template&id=1c055eb2"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js"

import "./ProfileDropdown.vue?vue&type=style&index=0&id=1c055eb2&lang=scss"
script.render = render

export default script